import {debounce, breakpoint} from '../utils/utilities.js';
var $ = jQuery;

function init() {

  function SocialSticky($context) {

    $($context).addClass('_sticky-added');

    this.$context = $context;
    this.$social = $($context).find('.article__social-container');
    this.$stickyContainer = $($context).find('.article__sticky-track');

    var self = this;

    binds(self);

    this.positions = getPositions(self);
  }

  function binds(self) {

    $(window).on('resize', debounce(function() {
      self.positions = getPositions(self);
      stickySocial(self);
    }, 250));

    $(window).on('scroll', function() {
      stickySocial(self);
    });
  }

  function stickySocial(self) {
    let currentPosition = $(window).scrollTop();
    let positions = getPositions(self);
    if(positions.breakpoint === 'desktop') {
      if(currentPosition > positions.appearPoint && currentPosition < positions.bottom) {
        $(self.$social).addClass('_sticky');
        $(self.$social).css({'left': positions.left});
        $(self.$social).css({'top': positions.top});
      }
      else {
        $(self.$social).removeClass('_sticky');
        $(self.$social).css({'left': 'initial', 'top': '0'});
      }
    }
    else {
      $(self.$social).removeClass('_sticky');
      $(self.$social).css({'left': 'initial', 'top': '0'});
    }

  }

  function getPositions(self) {

    var leftValue;
    var topValue;

    if ($('.navigation-global').length > 0) {
      leftValue = ($('.navigation-global').offset().left +  $('.navigation-global').outerWidth(false)) - 105;
      topValue = $(self.$context).offset().top - 110;
    }

    else if ($('.microsite-main-nav').length > 0) {
      leftValue = ($('#content .content-wrapper').offset().left +  $('.content-wrapper').outerWidth(false)) - 122;
      topValue = $(self.$context).offset().top - 50;
    }

    return {
      'top': topValue,
      'bottom': ($(self.$stickyContainer).offset().top +  $(self.$stickyContainer).outerHeight(true)) - 298,
      'left': leftValue,
      'breakpoint': breakpoint(),
      'appearPoint': ($(self.$stickyContainer).offset().top)
    };
  }

  if($('article.report').length > 0) {
    let $article = $('article.report');
    $article.each(function() {
      new SocialSticky($(this));
    });
  }

  $(document).on('newSectionAdded', function(e, context) {
    if($(context).hasClass('_sticky-added')) {
      return false;
    }

    var $newStick = $(context).find('article.report');
    if($newStick.length > 0) {
      new SocialSticky($newStick);
    }
  });
}


export { init as init };
